import { render } from "./platformFee.vue?vue&type=template&id=0195191a&scoped=true"
import script from "./platformFee.vue?vue&type=script&lang=js"
export * from "./platformFee.vue?vue&type=script&lang=js"

import "./platformFee.vue?vue&type=style&index=0&id=0195191a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0195191a"]])

export default __exports__